module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAxUlEQVQ4je2SPWqCQRRFjyKIdmkUhCjqJhQEcRupUqXISlJFcDOCIK7BKhJi4QZE7YSEEwZmIKhf4LOy8MGdn3ffve/BDGoWuupc/VRHWXVFzqMAvAJLoA6sgTkwAapn1SeOrdj1W31TyzH/rO7UL3XwV5MOBfVF3asrtX9h3Ed1pv6o72olGQRiGolxIjKQGh3UD7UXkps42vAf4Sna6kI9hkuIpxzihGYQXnqFXHE3uAWDUtxrQCenthGW8DW3wMNV7YFf51M9ligFQRUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/首页.png
// module id = ZeTu
// module chunks = 1